import axios from "axios";

export const DASHBOARD_URL = "/Dashboard";

/**  Mevcut Okula Ait Ana Sayfa (Dashboard) Verilerini Elde Eder */
export function getDashboardData() {
  return axios.get(DASHBOARD_URL);
}